import { CurrentUser, User, UserRoles } from '../types/User';

export const extractUserRole = (
  user: User | CurrentUser,
  ignoreSuperAdmin = false
) => {
  if (!ignoreSuperAdmin && user.accessRoles.includes(UserRoles.SUPER_ADMIN))
    return UserRoles.SUPER_ADMIN;

  if (user.accessRoles.includes(UserRoles.ORG_OWNER))
    return UserRoles.ORG_OWNER;

  if (user.accessRoles.includes(UserRoles.CODER)) return UserRoles.CODER;

  if (user.accessRoles.includes(UserRoles.USER)) return UserRoles.USER;

  return UserRoles.USER;
};
